// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.chart-container {
    width: 1200px;
    height: 100px;
    position: absolute;

}

.chartcss2 {
    height: 300px !important;
    margin-top: 300px;
}

@media screen and (max-width: 1301px) {
    .chart-container{
        width: 900px;
    }
}


/* @media screen and (max-width: 1500px) {
    .BodyPanel{
        top: 1800px;
    }
} */
`, "",{"version":3,"sources":["webpack://./src/styles/chart.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;GAuBG","sourcesContent":["/*.chart-container {\n    width: 1200px;\n    height: 100px;\n    position: absolute;\n\n}\n\n.chartcss2 {\n    height: 300px !important;\n    margin-top: 300px;\n}\n\n@media screen and (max-width: 1301px) {\n    .chart-container{\n        width: 900px;\n    }\n}\n\n\n/* @media screen and (max-width: 1500px) {\n    .BodyPanel{\n        top: 1800px;\n    }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
